export const CartActionTypes = {
  CART_ADD_ITEM: "CART_ADD_ITEM ",
  CART_REMOVE_ITEM: "CART_REMOVE_ITEM",
};
